import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

export const CertificationButtonWrapStyled = styled.div`
  position: relative;
  cursor: pointer;

  svg path {
    transition: fill 0.3s;
  }

  @media (hover: hover) {
    &:hover {
      svg path {
        fill: ${({ theme }) => theme.colors.highlight.variant1};
      }
    }
  }
`;

export const CertificationButtonStyled = styled(ButtonIcon)`
  border-radius: 0;
  background: none;
`;
